import { handleSmoothAnchorScroll } from "@/helpers/scrollToProductPicker";
import parse from "html-react-parser";

type GraphProps = {
  tr_heading: string;
  tr_description: string;
  tr_graph_label_1: string;
  tr_graph_label_2: string;
  graph_image?: string | null;
  cta?: {
    show: boolean;
    label: string;
    url: string;
  };
};

export const Graph = ({
  tr_heading,
  tr_description,
  tr_graph_label_1,
  tr_graph_label_2,
  graph_image,
  cta,
}: GraphProps) => (
  <div className="content-medium">
    <section className="pair-bioma-section">
      <h2 className="section-heading">{parse(tr_heading)}</h2>

      <div className="section-subtitle">{parse(tr_description)}</div>

      <div className="summary-section">
        {graph_image && (
          <div className="pair-bioma-image-container">
            <img src={graph_image} alt="" className="pair-bioma-image" />
          </div>
        )}

        <div className="chart-legend">
          <div className="legend-item">
            <div className="legend-indicator orange"></div>
            <span className="legend-text">{tr_graph_label_1}</span>
          </div>

          <div className="legend-item">
            <div className="legend-indicator blue"></div>
            <span className="legend-text">{tr_graph_label_2}</span>
          </div>
        </div>
      </div>

      {cta?.show && (
        <div className="cta-section">
          <a
            href={cta.url}
            className="pay-btn add-to-order-btn"
            onClick={(e) => handleSmoothAnchorScroll(e)}
          >
            {cta.label}
          </a>
        </div>
      )}
    </section>
  </div>
);
